<template>
  <section>
    <!--工具条-->
    <!-- <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar> -->
    <el-row type="flex" :gutter="10">
      <el-col :span="3">
        <el-input placeholder="配比标题" v-model="seachDm.key"></el-input>
      </el-col>
      <el-col :span="3">
        <el-input placeholder="强度等级" v-model="seachDm.GradeName"></el-input>
      </el-col>
      <el-col :span="4">
        <el-button type="primary" @click="getConsultRecipe(1)">查询</el-button>
        <el-button type="primary" @click="handleAdd()">新增</el-button>
      </el-col>
    </el-row>
    <!--列表-->
    <el-table
      :data="consultRecipe"
      highlight-current-row
      @current-change="selectCurrentRow"
      v-loading="listLoading"
      @selection-change="selsChange"
      style="width: 100%"
      height="600"
      :border="true"
    >
      <el-table-column label="标题" fixed>
        <template slot-scope="scope">
          <el-link type="primary" @click="handleDetail(scope.row)">
            {{ scope.row.Title }}
          </el-link>
        </template>
      </el-table-column>
      <el-table-column prop="IsPumping" label="是否泵送" width="">
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.IsPumping == 1 ? 'success' : 'info'"
            disable-transitions
          >
            {{ scope.row.IsPumping == 1 ? "是" : "否" }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="GradeName" label="强度等级"></el-table-column>
      <el-table-column prop="SpecMtlName" label="特殊材料"></el-table-column>
      <el-table-column prop="RecipeType" label="配比类型" width="">
        <template slot-scope="scope">
          <el-tag
            :type="scope.row.RecipeType == 1 ? 'success' : 'info'"
            disable-transitions
          >
            {{ scope.row.RecipeType == 1 ? "混凝土" : "砂浆" }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="140" fixed="right">
        <template slot-scope="scope">
          <el-link
            v-if="canEdit"
            type="primary"
            @click="
              () => {
                currentRow = scope.row;
                handleEdit();
              }
            "
          >
            编辑
          </el-link>
          <el-link
            v-if="canEdit"
            type="primary"
            @click="
              () => {
                currentRow = scope.row;
                handleCopy();
              }
            "
          >
            复制
          </el-link>
          <el-link
            v-if="canDelete"
            type="danger"
            @click="
              () => {
                sels.push(scope.row);
                handleDel();
              }
            "
          >
            删除
          </el-link>
          <el-link
            type="primary"
            @click="
              () => {
                currentRow = scope.row;
                handleHistry();
              }
            "
          >
            历史
          </el-link>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      layout="total, sizes, prev, pager, next, jumper"
      :page-size="pageSize"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
      class="my-pagination"
    ></el-pagination>

    <!-- 历史配比列表 -->
    <el-dialog
      title="历史配比列表"
      :visible.sync="histryShow"
      v-model="histryShow"
      :close-on-click-modal="false"
      append-to-body
    >
      <!--历史列表-->
      <el-table
        :data="histryData"
        highlight-current-row
        v-loading="listLoading"
        style="width: 100%"
      >
        <el-table-column label="标题">
          <template slot-scope="scope">
            <el-link type="primary" @click="handleDetail(scope.row)">
              {{ scope.row.Title }}
            </el-link>
          </template>
        </el-table-column>
        <el-table-column
          prop="GradeName"
          label="强度等级"
          sortable
        ></el-table-column>
        <el-table-column
          prop="SpecMtlName"
          label="特殊材料名称"
          sortable
        ></el-table-column>
        <el-table-column prop="IsPumping" label="是否泵送" width="">
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.IsPumping == 1 ? 'success' : 'info'"
              disable-transitions
            >
              {{ scope.row.IsPumping == 1 ? "是" : "否" }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="CreateUser"
          label="创建人"
          sortable
        ></el-table-column>
        <el-table-column
          prop="CreateTime"
          label="创建时间"
          sortable
        ></el-table-column>
      </el-table>
      <el-pagination
        layout="total, sizes, prev, pager, next, jumper"
        :page-size="histrypageSize"
        :total="histrytotal"
        @current-change="histryCurrentChange"
        @size-change="histrySizeChange"
        class="my-pagination"
      ></el-pagination>
    </el-dialog>
    <!-- 配方详情 -->
    <el-dialog
      :title="ConsultRecipeDetail.ConsultRecipe.Title"
      :visible.sync="isShowConsultRecipeDetailPage"
    >
      <table class="table-bordered" style="">
        <tr>
          <th>强度等级</th>
          <td>
            {{ ConsultRecipeDetail.ConsultRecipe.GradeName }}/{{
              ConsultRecipeDetail.ConsultRecipe.SpecMtlName
            }}
          </td>
          <th>是否泵送</th>
          <td>
            {{ ConsultRecipeDetail.ConsultRecipe.IsPumping == 1 ? "是" : "否" }}
          </td>
        </tr>
        <tr>
          <th>坍落度</th>
          <td>{{ ConsultRecipeDetail.ConsultRecipe.TLD }}</td>
          <th>搅拌时间</th>
          <td>{{ ConsultRecipeDetail.ConsultRecipe.MixingTime }}</td>
        </tr>
        <tr>
          <th>备注</th>
          <td>{{ ConsultRecipeDetail.ConsultRecipe.Remark }}</td>
          <th>生产线</th>
          <td>{{ ConsultRecipeDetail.ConsultRecipe.StationLineName }}</td>
        </tr>
      </table>
      <h4>
        {{
          ConsultRecipeDetail.ConsultRecipe.RecipeType == 1 ? "混凝土" : "砂浆"
        }}配比
      </h4>
      <el-table :data="ConsultRecipeDetail.ConsultRecipeSubList">
        <el-table-column prop="MatClassName" label="物资类型"></el-table-column>
        <el-table-column
          prop="WarehouseName"
          label="仓库名称"
        ></el-table-column>
        <el-table-column prop="Quantity" label="用量"></el-table-column>
      </el-table>
      <el-form :model="ConsultRecipeDetail" label-width="120px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="">
              容重：{{ ConsultRecipeDetail.ConsultRecipe.BulkDensity }}Kg
              砂率：{{ ConsultRecipeDetail.ConsultRecipe.SL }} 水胶比：{{
                ConsultRecipeDetail.ConsultRecipe.SJB
              }}
              F：{{ ConsultRecipeDetail.ConsultRecipe.FProportion }} K：{{
                ConsultRecipeDetail.ConsultRecipe.KProportion
              }}
              A：{{ ConsultRecipeDetail.ConsultRecipe.AProportion }}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>

    <!-- 新增修改 -->
    <el-dialog
      :title="isEdit ? '修改' : '新增'"
      :visible.sync="showForm"
      v-model="showForm"
      :close-on-click-modal="false"
      width="90%"
    >
      <div style="height: 550px; overflow: auto; overflow-x: hidden">
        <el-form
          label-width="100px"
          ref="dm"
          :rules="addFormRules"
          :model="dm"
          size="mini"
        >
          <el-row>
            <el-col :span="16">
              <el-form-item label="配方标题" prop="Title">
                <el-input v-model="dm.Title"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="配方类型">
                <el-radio v-model="dm.RecipeType" :label="1">混凝土</el-radio>
                <el-radio v-model="dm.RecipeType" :label="2">砂浆</el-radio>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="强度等级" prop="GradeName">
                <el-select
                  v-model="dm.GradeName"
                  filterable
                  placeholder="请选择"
                  @change="selectGrade"
                >
                  <el-option
                    v-for="item in basedata.GradeList"
                    :key="item.Id + '_qd'"
                    :label="item.Name"
                    v-model="item.Id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="">
                <el-switch
                  v-model="dm.IsPumping"
                  :active-value="1"
                  :inactive-value="0"
                  active-text="泵送"
                  inactive-text="非泵"
                ></el-switch>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="坍落度">
                <el-select
                  v-model="dm.TLD"
                  filterable
                  placeholder="请选择"
                  @change="selectTld"
                >
                  <el-option
                    v-for="item in basedata.TldList"
                    :key="item.Id + '_tld'"
                    :label="item.Name"
                    v-model="item.Id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item label="搅拌时间">
                <el-input v-model="dm.MixingTime"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6" :offset="2">
              <el-form-item label="备注">
                <el-input v-model="dm.Remark"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6" :offset="2">
              <el-form-item label="生产线">
                <el-select
                  v-model="dm.StationLineID"
                  placeholder="请选择"
                  @change="selectStation"
                >
                  <el-option
                    v-for="item in basedata.SysStationLineList"
                    :key="item.Id + '_station'"
                    :label="item.Name"
                    v-model="item.Id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <el-form-item label="特殊材料">
            <el-checkbox-group v-model="specMtlIDList">
              <el-checkbox
                v-for="item in basedata.SpecialMaterialList"
                :label="item.Id"
                :key="item.Id + '_ts'"
                @change="changeSpecialMaterial(item, $event)"
              >
                {{ item.Name }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item> -->
        </el-form>
        <h3>配方明细</h3>
        <el-form size="mini">
          <el-row
            :gutter="20"
            type="flex"
            justify="space-around"
            class="row-center"
          >
            <el-col :span="6">物料类型</el-col>
            <el-col :span="6">仓库</el-col>
            <el-col :span="6">物料用量（千克）</el-col>
            <el-col :span="6">备注</el-col>
            <el-col :span="6">操作</el-col>
          </el-row>
          <el-row
            :gutter="20"
            type="flex"
            justify="space-around"
            v-for="(item, index) in recipeSubList"
            :key="index"
          >
            <el-col>
              <el-form-item>
                <el-select
                  v-model="item.MatClassName"
                  @change="recipeTableSelectChange($event, index)"
                  style="width: 100%"
                >
                  <el-option
                    v-for="material in basedata.MaterialClassList"
                    :label="material.Name"
                    :key="material.Id + '_addmatclass'"
                    :value="material.Id"
                    v-model="material.Id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item>
                <el-select
                  v-model="item.WarehouseName"
                  @change="recipeWhSelectChange($event, index)"
                  filterable
                  style="width: 100%"
                >
                  <el-option
                    v-for="wh in basedata.SysRecipeMappingList.filter(
                      (e) => e.MatClassID == item.MatClassID
                    )"
                    :label="wh.WarehouseName"
                    :key="wh.Id + '_WarehouseID_' + index"
                    :value="wh.WarehouseID"
                    v-model="wh.WarehouseID"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item>
                <el-input
                  v-model="item.Quantity"
                  @input="changequantity"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item>
                <el-input v-model="item.Remark"></el-input>
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item style="text-align: center">
                <el-button type="danger" @click="recipeTableRemoveRow(index)">
                  删除
                </el-button>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-button @click="recipeTableAddRow">新增行</el-button>
          </el-row>
        </el-form>
        <el-form size="mini">
          <el-row
            :gutter="20"
            type="flex"
            justify="space-around"
            class="row-center"
          >
            <el-col>
              <el-form-item label="砂率">
                <el-input v-model="dm.SL"></el-input>
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label="水胶比">
                <el-input v-model="dm.SJB"></el-input>
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label="容重">
                <el-input v-model="dm.BulkDensity" readonly=""></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            :gutter="20"
            type="flex"
            justify="space-around"
            class="row-center"
          >
            <el-col>
              <el-form-item label="F掺量">
                <el-input v-model="dm.FProportion"></el-input>
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label="K掺量">
                <el-input v-model="dm.KProportion"></el-input>
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item label="A掺量">
                <el-input v-model="dm.AProportion"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="showForm = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="addSubmit"
          :loading="addLoading"
        >
          提交
        </el-button>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import util from "../../../util/date";
import * as api from "../../api/recipe";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";

export default {
  components: { Toolbar },
  data() {
    return {
      buttonList: [],
      seachDm: {
        key: "",
        GradeName: "",
      },
      total: 0,
      page: 1,
      pageSize: 20,
      currentRow: null,
      listLoading: false,
      stationLine: [],
      materialClassList: [],
      specMtlID: [],
      specMtlName: [],
      dm: {}, //模型
      recipeSubList: [], //配方明细
      specMtlIDList: [],
      showForm: false, //窗口显示
      basedata: {}, //基础数据
      consultRecipe: [], //列表数据
      addLoading: false,
      addForm: {},
      addFormRules: {
        Title: [{ required: true, message: "请输入配比名称", trigger: "blur" }],
        GradeName: [
          { required: true, message: "请选择强度等级", trigger: "blur" },
        ],
      },
      subIndex: 0, //子条目Id
      isEdit: false, //是否为编辑 true为编辑 默认新增
      histryData: [], //历史记录
      histrytotal: 0, //历史记录翻页
      histrypage: 1,
      histrypageSize: 20,
      histryShow: false,
      isShowConsultRecipeDetailPage: false,
      ConsultRecipeDetail: {
        ConsultRecipe: {},
        ConsultRecipeSubList: [],
      },
    };
  },

  mounted() {
    this.getConsultRecipeData();
    this.getConsultRecipe();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];

    this.buttonList = getButtonList(this.$route.path, routers);
  },
  computed: {
    //计算属性,判断是否有权编辑
    canEdit() {
      let index = this.buttonList.findIndex(
        (s) => s.name === "编辑" || s.name === "修改"
      );
      return index > -1;
    },
    //计算属性,判断是否有权删除
    canDelete() {
      let index = this.buttonList.findIndex((s) => s.name === "删除");
      return index > -1;
    },
  },
  methods: {
    //单击表格行事件绑定方法
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    //翻页事件绑定方法
    handleCurrentChange(val) {
      this.page = val;
      this.getConsultRecipe();
    },
    //获取列表
    getConsultRecipe(optype) {
      if (optype == 1) {
        this.page = 1;
      }
      let para = {
        page: this.page,
        key: this.seachDm.key,
        gradeName: this.seachDm.GradeName,
        intPageSize: this.pageSize,
      };
      this.listLoading = true;
      api.getConsultRecipeListPage(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.consultRecipe = res.data.response.data;
        this.listLoading = false;

        this.currentRow = null;
        this.sels = [];
      });
    },
    //执行删除
    handleDel() {
      if (!this.sels || this.sels.length <= 0) {
        this.$message({
          message: "请勾选要删除的数据",
          type: "error",
        });

        return;
      }
      this.$confirm("确认删除选中的记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;

          let para = this.sels.map((item) => item.Id);

          api.batchDelete(para).then((res) => {
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.getConsultRecipe();
          });
        })
        .catch(() => {})
        .finally(() => {
          this.listLoading = false;
        });
    },
    //勾选表格数据事件绑定方法
    selsChange(sels) {
      this.sels = sels;
    },
    //翻页事件绑定方法
    histryCurrentChange(val) {
      this.histrypage = val;
      this.getHistry();
    },
    //获取历史列表
    getHistry() {
      let para = {
        page: this.histrypage,
        key: this.currentRow.Code,
        intPageSize: this.histrypageSize,
      };
      this.listLoading = true;
      api.getHistryByPage(para).then((res) => {
        this.histrytotal = res.data.response.dataCount;
        this.histryData = res.data.response.data;
        this.listLoading = false;
      });
    },
    //查看历史列表
    handleHistry() {
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要查看的一行数据！",
          type: "error",
        });
        return;
      }
      this.histryShow = true;
      this.getHistry();
    },
    //切换分页大小绑定方法
    histrySizeChange(size) {
      this.histrypageSize = size;
      this.getHistry();
    },
    // 显示窗口
    handleDetail(row) {
      this.getConsultRecipeDetail(row.Id);
      this.isShowConsultRecipeDetailPage = !this.isShowConsultRecipeDetailPage;
    },
    // 获取配方详情
    getConsultRecipeDetail(id) {
      let para = {
        id: id,
      };
      api.getConsultRecipeDetail(para).then((data) => {
        if (!data.data.success) {
          this.ConsultRecipeDetail = [];
          tihs.$message("获取失败");
          return;
        }
        this.ConsultRecipeDetail = data.data.response;
      });
    },
    //切换分页大小绑定方法
    handleSizeChange(size) {
      this.pageSize = size;
      this.getConsultRecipe(1);
    },
    //显示新增界面
    handleAdd() {
      this.isEdit = false;
      this.showForm = true;
      this.dm = { RecipeType: 1 };
      this.specMtlID = [];
      this.specMtlName = [];
      this.recipeSubList = [];
      this.specMtlIDList = [];
    },
    //执行新增
    addSubmit() {
      this.addForm = {
        ConsultRecipe: this.dm,
        ConsultRecipeSubList: this.recipeSubList,
      };
      if (this.recipeSubList.length < 1) {
        {
          this.$message({
            message: "请添加配比详情！",
            type: "error",
          });
          return;
        }
      }
      this.$refs.dm.validate((valid) => {
        if (valid) {
          this.changequantity();
          this.addLoading = true;
          let para = Object.assign({}, this.addForm);
          let user = JSON.parse(window.localStorage.user);

          if (user && user.uID > 0) {
          } else {
            this.$message({
              message: "登录信息已过期,请重新登录",
              type: "error",
            });
            this.$router.replace(
              this.$route.query.redirect ? this.$route.query.redirect : "/"
            );
          }
          if (this.isEdit) {
            api
              .editConsultRecipe(para)
              .then((res) => {
                if (res && res.data && res.data.success) {
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.$refs["dm"].resetFields();
                  this.showForm = false;
                  this.addLoading = false;
                  this.getConsultRecipe();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              })
              .finally(() => {
                this.showForm = false;
                this.addLoading = false;
              });
          } else {
            api
              .addConsultRecipePost(para)
              .then((res) => {
                if (res && res.data && res.data.success) {
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  this.$refs["dm"].resetFields();
                  this.showForm = false;
                  this.getConsultRecipe();
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              })
              .finally(() => {
                this.showForm = false;
                this.addLoading = false;
              });
          }
        }
      });
    },
    //复制配比
    handleCopy() {
      this.isEdit = false;
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });

        return;
      }
      this.showForm = true;
      this.listLoading = true;
      this.dm = {};
      this.specMtlID = [];
      this.specMtlName = [];
      this.recipeSubList = [];
      let para = {
        id: row.Id,
      };
      api.getConsultRecipeDetail(para).then((res) => {
        this.listLoading = false;
        this.dm = res.data.response.ConsultRecipe;
        this.recipeSubList = res.data.response.ConsultRecipeSubList;
        this.subIndex = Math.max(...this.recipeSubList.map((a) => a.Id));
        if (
          res.data.response.ConsultRecipe.SpecMtlName &&
          res.data.response.ConsultRecipe.SpecMtlName.length > 0
        ) {
          this.specMtlID = res.data.response.ConsultRecipe.SpecMtlID.split(",");
          this.specMtlName = res.data.response.ConsultRecipe.SpecMtlName.split(
            ","
          );
        }
        this.specMtlIDList = this.specMtlID;
      });
    },
    //显示编辑界面
    handleEdit() {
      this.isEdit = true;
      let row = this.currentRow;
      if (!row) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });

        return;
      }
      this.showForm = true;
      this.listLoading = true;
      this.dm = {};
      this.specMtlID = [];
      this.specMtlName = [];
      this.recipeSubList = [];
      this.isEdit = true;
      let para = {
        id: row.Id,
      };
      api.getConsultRecipeDetail(para).then((res) => {
        this.listLoading = false;
        this.dm = res.data.response.ConsultRecipe;
        this.recipeSubList = res.data.response.ConsultRecipeSubList;
        this.subIndex = Math.max(...this.recipeSubList.map((a) => a.Id));
        if (
          res.data.response.ConsultRecipe.SpecMtlName &&
          res.data.response.ConsultRecipe.SpecMtlName.length > 0
        ) {
          this.specMtlID = res.data.response.ConsultRecipe.SpecMtlID.split(",");
          this.specMtlName = res.data.response.ConsultRecipe.SpecMtlName.split(
            ","
          );
        }
        this.specMtlIDList = this.specMtlID;
      });
    },
    //获取物料规格
    recipeTableSelectChange(Id, index) {
      var matItem = this.basedata.MaterialClassList.filter(
        (x) => x.Id == Id
      )[0];
      this.recipeSubList[index].MatClassName = matItem.Name;
      this.recipeSubList[index].MatClassID = Id;
      this.recipeSubList[index].MatClassTypeCode = matItem.TypeCode;
    },
    recipeWhSelectChange(Id, index) {
      var matItem = this.basedata.SysRecipeMappingList.filter(
        (x) => x.WarehouseID == Id
      )[0];
      this.recipeSubList[index].WarehouseName = matItem.WarehouseName;
      this.recipeSubList[index].WarehouseID = matItem.WarehouseID;
    },
    selectStation(id) {
      this.dm.StationLineID = id;
      this.dm.StationLineName = this.basedata.SysStationLineList.filter(
        (e) => e.Id == id
      )[0].Name;
    },
    //配方明细添加行
    recipeTableAddRow() {
      this.subIndex += 1;
      this.recipeSubList.push({ Id: this.subIndex });
    },
    //配方明细删除行
    recipeTableRemoveRow(index) {
      this.recipeSubList.splice(index, 1);
    },
    //获取基础数据
    getConsultRecipeData() {
      api.getConsultRecipeBaseData().then((res) => {
        this.basedata = res.data.response;
      });
    },
    //强度等级改变时触发
    selectGrade(id) {
      var value = this.basedata.GradeList.filter((e) => e.Id == id)[0];
      this.dm.GradeID = value.Id;
      this.dm.GradeName = value.Name;
    },
    //坍落度改变时触发
    selectTld(id) {
      var value = this.basedata.TldList.filter((e) => e.Id == id)[0];
      this.dm.TLD = value.Name;
    },
    //特殊材料选择
    changeSpecialMaterial(value, isTrue) {
      if (isTrue) {
        this.specMtlID.push(value.Id);
        this.specMtlName.push(value.Name);
      } else {
        this.specMtlID.splice(
          this.specMtlID.findIndex((x) => x === value.Id),
          1
        );
        this.specMtlName.splice(
          this.specMtlName.findIndex((x) => x === value.Name),
          1
        );
      }
      this.dm.SpecMtlID = this.specMtlID.toString();
      this.dm.SpecMtlName = this.specMtlName.toString();
    },
    changequantity() {
      /* 
    砂率=砂/骨料、水胶比=水/粉料、F掺量=粉煤灰/粉料、K掺量=矿粉/粉料、A掺量=外加剂/粉料。 
    材料类型码：
    水：10，
    备用：20，
    骨料：30，砂子：301，石子：302
    粉料：40，水泥：401，粉煤灰：402，矿粉：403，
    外加剂：50
    */
      //-------- 计算比例 开始
      var warterTotal = 0; //水
      var sandTotal = 0; //砂
      var cementTotal = 0; //水泥
      var flyashTotal = 0; //粉煤灰
      var breezeTotal = 0; //矿粉
      var additiveTotal = 0; //外加剂
      var powderTotal = 0; //粉料
      var aggregateTotal = 0; //骨料
      var bulkDensity = 0; //容重

      this.recipeSubList.map((e) => {
        var quantity =
          e.Quantity == "" || e.Quantity == undefined ? 0 : Number(e.Quantity);
        bulkDensity += quantity;
        var matItemLis = this.basedata.MaterialClassList.filter(
          (k) => k.Id == e.MatClassID
        );
        var matItem = null;
        if (matItemLis != null && matItemLis.length > 0) {
          matItem = matItemLis[0];
        }
        var typeCode = "";
        if (matItem != null) {
          typeCode = matItem.TypeCode;
        }
        if (typeCode == "") {
        } else {
          if (typeCode.indexOf("1") == 0) {
            warterTotal += Number(quantity);
          } else if (typeCode.indexOf("2") == 0) {
          } else if (typeCode.indexOf("3") == 0) {
            aggregateTotal += Number(quantity);

            if (typeCode == "301") {
              sandTotal += Number(quantity);
            }
          } else if (typeCode.indexOf("4") == 0) {
            powderTotal += Number(quantity);

            if (typeCode == "401") {
              cementTotal += Number(quantity);
            }
            if (typeCode == "402") {
              flyashTotal += Number(quantity);
            }
            if (typeCode == "403") {
              breezeTotal += Number(quantity);
            }
          } else if (typeCode.indexOf("5") == 0) {
            additiveTotal += Number(quantity);
          }
        }
      });
      this.dm.SL = (aggregateTotal == 0
        ? 0
        : sandTotal / aggregateTotal
      ).toFixed(4); //砂率
      this.dm.SJB = (powderTotal == 0 ? 0 : warterTotal / powderTotal).toFixed(
        4
      ); //水胶比
      this.dm.FProportion = (powderTotal == 0
        ? 0
        : flyashTotal / powderTotal
      ).toFixed(4); //F掺量
      this.dm.KProportion = (powderTotal == 0
        ? 0
        : breezeTotal / powderTotal
      ).toFixed(4); //K掺量
      this.dm.AProportion = (powderTotal == 0
        ? 0
        : additiveTotal / powderTotal
      ).toFixed(4); //A掺量
      this.dm.BulkDensity = bulkDensity;
    },
  },
};
</script>

<style lang="less">
.row-center {
  margin: 20px auto;

  .el-col {
    text-align: center;
  }
}
</style>
